<!-- 共通関数:主にjqueryによる画面効果、アニメーション -->
<script>
export default {
  name: 'common',
  methods: {
    /**
     * 前に戻る
     */
    prev() {
      $('#container').css('position', 'absolute');
      $('div#popupBasic-popup').css('display', 'none');
      $('#container div').css('width', `${$(window).width()}px`);
      $('#container').animate({
        left: `${$(window).width()}px`,
        opacity: '0',
      }, 500, () => {
        this.$parent.backView();
      });
    },
    /**
     * 次に進む
     */
    next(routerData) {
      $('#container').css('position', 'absolute');
      $('div#popupBasic-popup').css('display', 'none');
      $('#container').find().css('width', 'auto');
      $('#container').animate({
        left: `-=${$(window).width()}px`,
        opacity: '0',
      }, 500, () => {
        this.$router.push(routerData);
      });
    },
    /**
     * ページトップ
     */
    pageTop() {
      $('html,body').animate({ scrollTop: 0 }, 'slow', 'swing');
    },
    pageScroll(scrollY) {
      $('html,body').animate({ scrollTop: scrollY }, 'fast', 'swing');
    },
  },
  mounted() {
    // 画面表示時のフェードイン
    $('#container').animate({ opacity: '1' }, 500);
    $('body').removeAttr('style');
  },
};
</script>
